export default class CommentsArranger {

    static prepareData(data) {


        let result = CommentsArranger.renameProperties(data);
        result.count = CommentsArranger.calculateCount(result);

        result.isFirstLevel = true;
        return result;
    }

    static getIdList(obj) {
        let arr = [];
        if (obj.items && obj.items.length) {
            obj.items.forEach((item) => {
                arr.push(item.id);
                arr = arr.concat(CommentsArranger.getIdList(item))
            })
        }
        return arr;
    }

    static renameProperties(data) {
        data.items = data.comments || data.replies;
        if (data.items && data.items.length) {
            data.items.forEach((item) => {
                item = CommentsArranger.renameProperties(item);
            })
        }

        return data;
    }

    static calculateCount(data) {
        if (!data.items) {
            return 0;
        }
        let count = data.items.length;
        data.items.forEach((item)=> {
            item.count = CommentsArranger.calculateCount(item);
            count += item.count;
        });

        return count;

    }

    static setDepth(arr, depth) {

        if (arr.length) {
            arr.forEach((item) => {
                item.depth = depth;
                if (depth >= 2) {
                    item.isReplyBanned = true;
                }
                if (item.items && item.items.length )
                    item.items = CommentsArranger.setDepth(item.items, depth + 1);
            });
        }

        return arr;
    }

    static setLikes(data, likesArr) {
        const likes = likesArr.slice();
        if (data.items && data.items.length) {
            data.items.forEach((item) => {
                likes.forEach((like, i) => {
                    if (like.contentId === item.id) {
                        item.likesCount = like.count;
                        item.isLiked = like.isLiked;
                        likesArr.splice(i,1);
                    }
                });
                item = CommentsArranger.setLikes(item, likes);
            })
        }
        return data;
    }
}









// WEBPACK FOOTER //
// ./components/comments/scripts/comments-arranger.js